export const SET_LITERALS = "SET_LITERALS" as "SET_LITERALS";

export type LiteralAction = | { type: typeof SET_LITERALS; language: string};
